import { render, staticRenderFns } from "./CreateVariable.vue?vue&type=template&id=0eefad5a&"
import script from "./CreateVariable.vue?vue&type=script&lang=js&"
export * from "./CreateVariable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eefad5a')) {
      api.createRecord('0eefad5a', component.options)
    } else {
      api.reload('0eefad5a', component.options)
    }
    module.hot.accept("./CreateVariable.vue?vue&type=template&id=0eefad5a&", function () {
      api.rerender('0eefad5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Story/Modals/CreateVariable.vue"
export default component.exports